import { render, staticRenderFns } from "./WidgetsBooking.vue?vue&type=template&id=18a91f80"
import script from "./WidgetsBooking.vue?vue&type=script&lang=js"
export * from "./WidgetsBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports